import { Project } from "./Company";
import { ProjectQuizBucket } from "./Quiz";
import { NotifyEvents } from "./Notifications";
import { Label, SpecialistTagsDirections } from "./TypeSpecialist";
import { TypeUserData } from "./TypeUsers";

export enum HubInvitationStatus {
  PENDING = "pending",
  ACCEPTED = "accepted",
  DECLINED = "declined",
}

export enum ProjectTeamRole {
  OWNER = "owner",
  MANAGER = "manager",
  SUPERVISOR = "supervisor",
}

export enum ProjectsAvailableSessionTypes {
  SESSION = "SESSION",
  REAL_TIME_SESSION = "REAL_TIME_SESSION",
  PACKAGE = "PACKAGE",
}

export enum ProjectRoles {
  DEEFAULT_USER = "DEEFAULT_USER",
  SPECIALIST = "SPECIALIST",
}
export type TypeNewNotify = {
  title: string;
  message?: string;
  date: Date;
  from?: string;
  for: string;
  projectEntryCode?: string;
  companyEntryCode?: string;
  messageFrom?: string;
  labels: { text: string; language: string }[];
  notifyType: string;
  event?: NotifyEvents;
  projectId?: string;
};
export type TypeNewProject = {
  title: Label[];
  description: Label[];
  adminRemarkForExperts?: Label[];
  briefDescription?: Label[];
  enableTwilioSms: boolean;
  allowSpecialistLeave: boolean;
  allowSpecialistPause: boolean;
  video?: File;
  isPrivate: boolean;
  isPublicAccess?: boolean;
  avatar?: string;
  creationDate?: Date;
  endDate?: Date;
  clientLimit: number;
  specialistLimit: number;
  clients?: string[];
  specialists?: string[];
  sessionDiscount?: number;
  packageDiscount?: number;
  realTimeSessionDiscount?: number;
  treeQuizTagsToSkip?: string[];
  availableSessionTypes?: {
    type: ProjectsAvailableSessionTypes;
    amount: number;
    unlimited: boolean;
    specialization: string;
  }[];
  isBarter?: boolean;
  specializations?: string[];
  pricing?: {
    price?: number;
    discount?: number;
    tax?: number;
    level: string;
  }[];
  packagePricing?: {
    price?: number;
    discount?: number;
    tax?: number;
    level: string;
  }[];
  clientCancelThreshold?: number;
  specialistCancelThreshold?: number;
  clientRescheduleThreshold?: number;
  clientCancelPackageThreshold?: number;
  clientReschedulePackageThreshold?: number;
  clientReschedulePackageAmount?: number;
  skipSpecialistConfirmation?: boolean;
  packageTax?: number;
  sessionTax?: number;
  staticSessionPrices: boolean;
  staticPackagePrices: boolean;
  offerPromoPackages: boolean;
  skipSpecialistRecordConfirmation: boolean;
  quizBuckets?: ProjectQuizBucket[];
};

export type TypeNewTag = {
  _id?: string;
  title: string;
  labels: { language: string; text: string }[];
  direction: SpecialistTagsDirections;
  tags?: TypeNewTag[];
};

export type ProjectTeamInvitation = {
  _id: string;
  project: Project;
  roles: (ProjectTeamRole | string)[];
  invitedBy: TypeUserData;
  invitedUser: TypeUserData;
  invitedAt: string;
  status: HubInvitationStatus;
  respondedAt?: string;
};
